module.exports = __webpack_public_path__ + "static/UnclickLiabilityYellow-d0c6cc2a1a955f3239ec34beb52caf4b.png";